import timezonesData from "countries-and-timezones";

export const formattedTimezonesData = Object.keys(timezonesData.getAllTimezones()).map(key => {
  return key;
});
